import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { HandoverDetailComponent } from './handover-detail.component';

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateHoDetailGuard {
  canDeactivate(
    component: HandoverDetailComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    console.log(currentRoute.paramMap.get('id'));
    console.log(currentState.url);
    if (component.currentSectionHasPendingChanges) {
      return component.notifiyNavigationAwayFromMe();
    }
    if (component.footerHasPendingChanges) {
      return component.notifiyNavigationAwayFromMe(
        'Salir de Handover',
        'Recuerde que los comentarios del footer no se guardan, los mismos se perderan. ¿Está seguro que desea continuar?'
      );
    }
    return true;
  }
}
